module.exports = __webpack_public_path__ + "img/icn_clear.ee147ae2.svg";